import React from "react";
import ExistingPhotoPicker from "./ExistingPhotoPicker";
import PhotoUploader from "./PhotoUploader";

export default function InterludesEditor({ clientId, interludes, onChange }) {
  const update = (i, key, val) => {
    onChange(interludes.map((x, idx) => (idx === i ? { ...x, [key]: val } : x)));
  };
  const add = () =>
    onChange([
      ...interludes,
      { after_chapter: 1, photo_filename: null },
    ]);
  const remove = (i) => onChange(interludes.filter((_, idx) => idx !== i));

  return (
    <fieldset style={{ marginBottom: 24 }}>
      <legend><strong>Photos d'interlude</strong></legend>
      {interludes.map((inter, i) => (
        <div key={i} style={{ marginBottom: 12, padding: 8, border: "1px solid #eee", borderRadius: 4 }}>
          <label>Après chapitre :
            <input type="number" min={1} max={5}
                   value={inter.after_chapter}
                   onChange={(e) => update(i, "after_chapter", parseInt(e.target.value, 10))}
                   style={{ width: 60, marginLeft: 8 }} />
            <button onClick={() => remove(i)} style={{ marginLeft: 8 }}>×</button>
          </label>
          <div style={{ marginTop: 8 }}>
            <PhotoUploader
              clientId={clientId}
              slot={`interlude_${i + 1}`}
              currentFilename={inter.photo_filename}
              onChange={(filename) => update(i, "photo_filename", filename)}
            />
            <ExistingPhotoPicker
              clientId={clientId}
              onChange={(filename) => update(i, "photo_filename", filename)}
              ariaLabelSuffix={`comme photo d'interlude ${i + 1}`}
            />
          </div>
        </div>
      ))}
      <button onClick={add}>+ Ajouter une photo d'interlude</button>
    </fieldset>
  );
}
